export default __webpack_public_path__ + "static/media/icon-up.359200b2.svg";